import {
  Component,
  HostListener,
  Inject,
  inject,
  Input,
  Optional,
  PLATFORM_ID,
  Signal,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { LeadFormService } from '../../../reducers/services/lead-form.service';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  MatNativeDateModule,
  MatOptionModule,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Store } from '@ngrx/store';
import { getDestinations } from '../../../reducers/redux/actions';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  Observable,
  of,
  startWith,
  Subject,
  switchMap,
} from 'rxjs';
import { selectCurrentDestinations } from '../../../reducers/redux/selectors/destinations.selectors';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  MatBottomSheet,
  MatBottomSheetModule,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { DepartureModalWebComponent } from '../departure-modal-web/departure-modal-web.component';
import { MatIconModule } from '@angular/material/icon';
import { ViewportService } from '../../services/viewport.service';
import { MatDividerModule } from '@angular/material/divider';
import { LeadThankYouComponent } from '../thank-you-page/thank-you.component';
import { TravelersModalComponent } from '../travellers-modal/travellers-modal.component';
import { DestinationsService } from '../../../reducers/services/destinations.service';
import moment from 'moment';
import { CitiesService } from '../../../reducers/services/cities.service';
import { TimerService } from '../../services/timer.service';
import { AuthService } from '../../../reducers/services/auth.service';
import { getByIdUser } from '../../users/redux/selectors/users.selectors';
import { CoTravellerComponent } from '../co-traveller/co-traveller.component';
import { OnlyNumbersDirective } from '../../../shared/directives/only-numbers.directive';

import {
  agentEmailRegex,
  nonWhitespaceRequired,
} from '../../../utils/regex.utils';
import { ButtonComponent } from '../../../shared/components/buttons/button/button.component';
import { DualCalendarComponent } from '../dual-calendar/dual-calendar.component';

@Component({
  selector: 'app-lead-form-xl-v2',
  standalone: true,
  imports: [
    MatNativeDateModule,
    MatStepperModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatOptionModule,
    CommonModule,
    NgSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    // LeadFormComponent,
    MatBottomSheetModule,
    MatListModule,
    MatButtonModule,
    DepartureModalWebComponent,
    MatIconModule,
    // ButtonComponent,
    MatDividerModule,
    LeadThankYouComponent,
    TravelersModalComponent,
    OnlyNumbersDirective,
    ButtonComponent,
    DualCalendarComponent,
  ],
  templateUrl: './lead-form-xl-v2.component.html',
  styleUrl: './lead-form-xl-v2.component.scss',
  providers: [provideNativeDateAdapter(), TimerService],
})
export class LeadFormXlV2Component {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  selectedHolidayType: any;
  thirdFormGroup!: FormGroup;
  selectedTravelPlan!: string;
  selectedHotelCategory: any;
  selectedDepartureType: any;
  showThankYouPage = false;
  dynamicPlaceholder: string = '';
  coTravellerDynamicPlaceholder: string = '';
  @Input() viewMode: any = 'single';
  isFlightBooked: boolean | null = null;
  selectedOption: string | null = null;
  private store = inject(Store);
  leadId: string | null = null;
  public dialogRef = inject(MatDialogRef<LeadFormXlV2Component>);
  selectedValue: any;
  isAdultsDropdownVisible = false;
  isDropdownVisible = false;
  customCities: any[] = [];
  isSearchPerformed: boolean = false;
  isSearchDestination: boolean = false;
  destinationsState!: Signal<{ destinations: any }>;
  sessionTime = this.timerService.formattedTime;
  timerStarted = false;
  onSecondStep: boolean = true;
  flightStatus: string = 'need_to_book';
  planningToBook: any;
  travellerModalState: any = null;
  isSubmitting = false;
  @ViewChild('picker') picker!: any;
  @ViewChild('hiddenDateInput') hiddenDateInput!: any;
  dropdownPosition = {
    top: '0px',
    left: '0px',
    maxHeight: '0px',
    maxWidth: '0px',
    overflowY: 'hidden',
  };

  @ViewChild('bottomSheetTemplate') bottomSheetTemplate!: TemplateRef<any>;
  @ViewChild('bottomSheetTravellerTemplate')
  bottomSheetTravellerTemplate!: TemplateRef<any>;
  public _bottomSheet = inject(MatBottomSheet);
  public bottomSheetRef!: MatBottomSheetRef<any>;
  private destinationService = inject(DestinationsService);

  holidayTypes = [
    { type: 'friends', label: 'Friends' },
    { type: 'family', label: 'Family' },
    { type: 'honeymoon', label: 'Honeymoon' },
    { type: 'couple', label: 'Couple' },
  ];

  hotelCategories = [
    { category: '5_star', label: '5 Star' },
    { category: '4_star', label: '4 Star' },
    { category: '3_star', label: '3 Star' },
    { category: '2_star', label: '2 Star' },
  ];

  travelPlans = [
    { plan: 'immediate', label: 'Immediately' },
    { plan: 'this_week', label: 'This Week' },
    { plan: 'this_month', label: 'This Month' },
    { plan: 'later_sometime', label: 'Later Sometime' },
  ];

  departureType = [
    { plan: 'fixed', label: 'Fixed' },
    { plan: 'flexible', label: 'Flexible' },
  ];

  today = new Date();

  countryCodes = ['+91', '+66'];
  citySearch$ = new Subject<string>();
  filteredCities$!: Observable<any[]>;
  departureTypeInput: string = '';
  isEmailEntered = true;
  isPhoneEntered = true;
  isMobileView = false;
  txlButtonWidth = false;
  secondaryId: any;
  packageId: any;
  packageDealId: any;
  filteredDestinations!: any[];
  destinationsListItems: any[] = [];
  private searchTerms = new Subject<string>();
  isLoadingDestinations = false;
  isTravellerApplyEnabled = false;
  destinationSearch$ = new Subject<string>();
  filteredDepartments$!: Observable<any[]>;

  selectedDestination: string | undefined;

  isFlightBookedOptions = [
    { value: 'already_booked', label: 'Already Booked' },
    { value: 'need_to_book', label: 'Need to Book' },
    { value: 'not_needed', label: 'Not Needed' },
  ];
  tripDurationOptions: any[] = [
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8 - 10',
    '11 - 15',
    '15+',
  ];

  apiError: boolean = false;
  leadName!: string;
  leadPhone!: string;
  leadEmail!: string;
  destinationName!: string;
  cityName!: string;
  leadData: any;
  userData: any;
  packageDestination!: string;
  totalRooms!: number;
  totalAdults!: number;
  totalChildren!: number;
  totalInfants!: number;
  rooms: any;
  firstStepStatus: boolean = false;
  currentTripDurationIndex: number = 0;
  constructor(
    private _formBuilder: FormBuilder,
    private leadFormService: LeadFormService,
    private viewportService: ViewportService,
    public dialog: MatDialog,
    private timerService: TimerService,
    private citiesService: CitiesService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.sessionTime = this.timerService.formattedTime;
    const today = new Date().toISOString().split('T')[0];

    this.store.dispatch(
      getDestinations({ queryParams: { showCanonicals: false } })
    );
    this.destinationsState = toSignal(
      this.store.select(selectCurrentDestinations).pipe(
        startWith({ destinations: [], isLoading: false, error: null }),
        map((state: any) => {
          this.filteredDestinations = state?.destinations?.data || [];
          const preselectedItem = this.filteredDestinations.find(
            (item) => item._id === this.secondaryId
          );
          if (preselectedItem) {
            this.selectedDestination = preselectedItem._id;
          }
          return state
            ? { destinations: state.destinations?.data }
            : { destinations: [] };
        })
      ),
      { initialValue: { destinations: [] } }
    );

    this.destinationsListItems = this.destinationsState().destinations;

    this.firstFormGroup = this._formBuilder.group({
      to: [null, Validators.required],
      from: [null, Validators.required],
      fromOthers: [null],
      email: ['', [Validators.required, agentEmailRegex]],
      name: ['', [nonWhitespaceRequired]],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[6-9]\d{9}$/),
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      countryCode: ['+91'],
      departureType: ['fixed'],
      departureDate: [],
      tripDuration: [0], // Hardcoded default value for trip duration
      adults: [1],
      child: [],
      infant: [],
      sendUpdatesViaWhatsApp: [true],
    });

    this.secondFormGroup = this._formBuilder.group({
      flightStatus: ['need_to_book'],
      holidayType: [],
      hotelCategory: [],
      bookingTimeFrame: [],
      additionalInfo: [],
    });

    this.viewportService.getViewportWidth().subscribe((width: number) => {
      this.isMobileView = width > 768 ? false : true;
      this.txlButtonWidth = width > 800 ? false : true;
    });
  }

  updatePlaceholder() {
    const adults = this.firstFormGroup.get('adults')?.value;
    const children = this.firstFormGroup.get('child')?.value;
    const infants = this.firstFormGroup.get('infant')?.value;

    let placeholder = `${adults} Adult${adults !== 1 ? 's' : ''}`;

    if (children > 0) {
      placeholder += ` | ${children} Child${children !== 1 ? 'ren' : ''}`;
    }

    if (infants > 0) {
      placeholder += ` | ${infants} Infant${infants !== 1 ? 's' : ''}`;
    }

    this.dynamicPlaceholder = placeholder;
  }

  updateCoTravellerPlaceholder() {
    let placeholder = `${this.totalRooms} Room${
      this.totalRooms !== 1 ? 's' : ''
    }`;
    placeholder += `| ${this.totalAdults} Adult${
      this.totalAdults !== 1 ? 's' : ''
    }`;

    if (this.totalChildren > 0) {
      placeholder += ` | ${this.totalChildren} Child${
        this.totalChildren !== 1 ? 'ren' : ''
      }`;
    }

    if (this.totalInfants > 0) {
      placeholder += ` | ${this.totalInfants} Infant${
        this.totalInfants !== 1 ? 's' : ''
      }`;
    }
    this.coTravellerDynamicPlaceholder = placeholder;
  }

  ngOnInit(): void {
    if (this.data) {
      this.secondaryId =
        this.data.destinationId || this.data.exploreDestinationId || null;

      if (this.secondaryId) {
        this.firstFormGroup.get('to')?.patchValue(this.secondaryId);
      }

      this.packageId = this.data.packageId || null;
      this.packageDealId = this.data.packageDealId || null;
    }

    this.filteredDepartments$ = this.destinationSearch$.pipe(
      startWith(''),
      debounceTime(100),
      distinctUntilChanged(),
      switchMap((term: string | null | undefined) => {
        if (!term || term.trim() === '' || term.length < 3) {
          return of([]);
        }
        this.isSearchPerformed = true;
        return this.destinationService
          .getDestinationDropDown({ name: term, showCanonicals: true })
          .pipe(
            map((response: any) => {
              return response.data.filter(
                (item: any) => Object.keys(item).length > 0
              );
            })
          );
      })
    );
    // this.destinationsData();

    this.filteredCities$ = this.citySearch$.pipe(
      startWith(''),
      debounceTime(100),
      distinctUntilChanged(),
      switchMap((term: string | null) => {
        if (!term || term.trim() === '') {
          return of([]);
        }
        this.isSearchPerformed = true;
        return this.citiesService.searchCities({ name: term });
      })
    );

    // Idle detection setup
    this.timerService.startIdleDetection(() => {
      console.log('User is idle, pausing timer.');
    });

    if (this.data?.packageId || this.data?.dealId) {
      this.packageDestination = this.destinationsState()?.destinations?.find(
        (destination: any) => destination._id === this.secondaryId
      )?.name;
    }

    // Track form field interactions
    this.trackFormInteractions();
    this.userInfo();
    if (this.authService.isAuthenticated()) {
      this.firstFormGroup.patchValue({
        name: this.userData?.firstName,
        email: this.userData?.email,
      });
    }
  }

  destinationsData(): void {
    if (this.secondaryId) {
      this.destinationsListItems = this.filteredDestinations;
    } else {
      this.filteredDepartments$.subscribe((items: any[]) => {
        this.destinationsListItems = items;
      });
    }
  }

  onSearch(): void {
    this.destinationsData();
  }

  onCitySearch(term: string): void {
    this.citySearch$.next(term);
  }
  cityValue(event: any) {
    this.cityName = event?.name;
  }

  onDestinationSelected(selectedId: any): void {
    this.destinationName = selectedId.name;
    if (selectedId) {
      if (selectedId['isPrimary']) {
        this.secondaryId = selectedId._id;
      } else {
        this.isSearchDestination = true;
        if (selectedId._id.includes('_')) {
          this.secondaryId = selectedId._id.split('_')[1];
        } else {
          this.secondaryId = selectedId._id;
        }
      }
    }
    this.firstFormGroup.get('to')?.setValue(selectedId?._id);
  }

  trackFormInteractions(): void {
    this.firstFormGroup.valueChanges.subscribe(() => {
      if (!this.timerStarted) {
        this.timerService.start();
        this.timerStarted = true;
        console.log('Timer started on form interaction.');
      } else if (this.timerService.isIdle()) {
        this.timerService.resume();
        console.log('Timer resumed on form interaction.');
      }
      this.timerService.resetIdleTimer(() => {
        console.log('User is idle again, pausing timer.');
      });
    });
  }

  addTagFn(name: string) {
    this.firstFormGroup.get('from')?.setValue(null);
    this.firstFormGroup.get('fromOthers')?.setValue(name);

    this.firstFormGroup.get('from')?.markAsTouched();
    this.firstFormGroup.get('fromOthers')?.markAsTouched();

    return name;
  }

  increaseNoOfDay() {
    if (this.currentTripDurationIndex < this.tripDurationOptions.length - 1) {
      this.currentTripDurationIndex++;
      this.firstFormGroup
        .get('tripDuration')
        ?.setValue(this.tripDurationOptions[this.currentTripDurationIndex]);
    }
  }

  decreaseNoOfDay() {
    if (this.currentTripDurationIndex > 0) {
      this.currentTripDurationIndex--;
      this.firstFormGroup
        .get('tripDuration')
        ?.setValue(this.tripDurationOptions[this.currentTripDurationIndex]);
    }
  }

  selectFlightStatus(type: string) {
    this.flightStatus = type;
    this.secondFormGroup.controls['flightStatus']?.setValue(type);
  }

  selectPlanningToBookStatus(type: string) {
    this.planningToBook = type;
    this.secondFormGroup.controls['bookingTimeFrame']?.setValue(type);
  }

  selectHotelCategory(category: string) {
    this.selectedHotelCategory = category;
    this.secondFormGroup.controls['hotelCategory'].setValue(category);
  }

  selectHolidayType(type: string) {
    this.selectedHolidayType = type;
    this.secondFormGroup.controls['holidayType'].setValue(type);
  }

  userInfo() {
    this.store.select(getByIdUser).subscribe((res) => {
      if (res.currentData || Object.keys(res.currentData).length > 0) {
        this.userData = res?.currentData;
      }
    });
  }

  planMyTrip(stepper: MatStepper) {
    if (this.firstFormGroup.valid) {
      this.isSubmitting = true;
      const phoneControl = this.firstFormGroup.get('phone');
      const phoneValue = phoneControl?.value || '';
      const countryCode =
        this.firstFormGroup.get('countryCode')?.value || '+91';
      const sessionTime = this.timerService.getCurrentTime();

      const formData = {
        ...this.firstFormGroup.value,
        from: this.firstFormGroup.get('from')?.value || '',
        name: this.firstFormGroup.get('name')?.value.trim(),
        to: this.secondaryId,
        phone: phoneValue.startsWith(countryCode)
          ? phoneValue
          : `${countryCode}${phoneValue}`,
        leadSource: 'story',
        packageId: this.packageId ? this.packageId : null,
        sessionTime: sessionTime,
        rooms: this.rooms
          ? [...this.rooms]
          : [{ roomNumber: 1, adults: 1, child: 0, infant: 0 }],
      };
      if (
        formData['bookingTimeFrame'] &&
        typeof formData['bookingTimeFrame'] === 'object'
      ) {
        formData['bookingTimeFrame'] = formData['bookingTimeFrame'].plan;
      }

      delete formData['countryCode'];
      if (!formData['bookingTimeFrame']) delete formData['bookingTimeFrame'];

      // Handle departureType-specific fields
      if (formData['departureType'] == 'fixed') {
        formData['departureDate'] = moment(
          formData['departureDate'],
          'DD-MM-YYYY'
        ).format('DD-MM-YYYY');
      }

      const fromValue = this.firstFormGroup.get('from')?.value;
      const isCitySelected = this.customCities.some(
        (city) => city._id === fromValue
      );
      if (isCitySelected) {
        formData.from = fromValue;
        delete formData.fromOthers;
      } else {
        const fromOthersValue = this.firstFormGroup.get('fromOthers')?.value;
        if (fromOthersValue) {
          formData.fromOthers = fromOthersValue;
        } else {
          delete formData.fromOthers;
        }
      }
      if (this.isSearchDestination) {
        formData.requestedDestination = this.destinationName;
      } else {
        delete formData.requestedDestination;
      }
      const leadId = this.leadId || this.secondFormGroup.get('leadId')?.value;

      if (leadId) {
        this.leadFormService.updateLead(formData, leadId).subscribe({
          next: (response) => {
            console.log('Lead updated successfully', response);
            this.isSubmitting = false;
            this.apiError = false;
            this.leadId = response.id;
            this.setLeadIdToFormGroup();
            this.leadData = {
              ...response,
              destinationName: this.destinationName || '',
              cityName: this.cityName || '',
              packageDestination: this.packageDestination || '',
            };
            stepper.next();
            this.onSecondStep = false;
          },
          error: (error) => {
            console.error('Error updating lead', error);
            this.apiError = true;
          },
        });
      } else {
        this.leadFormService.createLead(formData).subscribe({
          next: (response) => {
            this.isSubmitting = false;
            this.apiError = false;
            this.leadName = response.name;
            this.leadPhone = response.phone.replace(/^\+\d{2}/, '');
            this.leadEmail = response.email;
            this.leadId = response.id;
            this.setLeadIdToFormGroup();
            this.firstStepStatus = true;

            this.leadData = {
              ...response,
              destinationName: this.destinationName || '',
              cityName: this.cityName || '',
              packageDestination: this.packageDestination || '',
            };
            stepper.next();
            this.onSecondStep = false;
          },
          error: (error) => {
            console.error('Error creating lead', error);
            this.apiError = true;
            this.isSubmitting = false;
          },
        });
      }
    } else {
      console.log('First form is invalid');
      this.isSubmitting = false;
    }
  }

  applyTravellerChanges(data: any): void {
    this.firstFormGroup.patchValue({
      adults: data.adultsCount,
      child: data.childrenCount,
      infant: data.infantsCount,
    });

    this.isAdultsDropdownVisible = false;

    this.updatePlaceholder();

    this.closeBottomSheet();
  }

  setLeadIdToFormGroup() {
    if (this.leadId) {
      this.secondFormGroup.patchValue({ leadId: this.leadId });
    } else {
      console.log('LeadID is not available yet');
    }
  }

  onSubmit() {
    if (this.secondFormGroup.valid) {
      this.isSubmitting = true;
      const sessionTime = this.timerService.getCurrentTime();

      const formData = {
        flightStatus: this.secondFormGroup.get('flightStatus')?.value || '',
        bookingTimeFrame:
          this.secondFormGroup.get('bookingTimeFrame')?.value || '',
        hotelCategory: this.secondFormGroup.get('hotelCategory')?.value || '',
        additionalInfo: this.secondFormGroup.get('additionalInfo')?.value || '',
        holidayType: this.secondFormGroup.get('holidayType')?.value || '',
        sessionTime: sessionTime,
      };

      if (!formData['flightStatus']) delete formData['flightStatus'];
      if (!formData['bookingTimeFrame']) delete formData['bookingTimeFrame'];
      if (!formData['holidayType']) delete formData['holidayType'];
      if (!formData['hotelCategory']) delete formData['hotelCategory'];
      if (!formData['additionalInfo']) delete formData['additionalInfo'];

      const leadId = this.leadId || this.secondFormGroup.get('leadId')?.value;

      if (leadId) {
        this.leadFormService.updateLead(formData, leadId).subscribe({
          next: (response) => {
            // this.dialogRef.close();
            this.isSubmitting = false;
            this.timerService.stop();
            this.timerStarted = false;

            this.showThankYouPage = true;
          },
          error: (error) => {
            console.error('Error updating lead', error);
            this.isSubmitting = false;
          },
        });
      } else {
        console.error('Lead ID is not available. Cannot update lead.');
        this.isSubmitting = false;
      }
    } else {
      console.log('Second form is invalid');
      this.isSubmitting = false;
    }
  }

  openTravellerBottomSheet(): void {
    this.bottomSheetRef = this._bottomSheet.open(
      this.bottomSheetTravellerTemplate,
      {
        panelClass: 'lead-bottom-sheet',
      }
    );
  }

  closeBottomSheet(): void {
    if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss();
    }
  }

  closeModal() {
    if (this.leadData && !this.showThankYouPage) {
      this.showThankYouPage = true;
      this.timerService.reset();
      return;
    }
    this.timerService.reset();
    this.dialogRef.close();
  }

  goBack(stepper: MatStepper) {
    this.onSecondStep = true;
    stepper.previous();
  }

  openDropdown(event: MouseEvent): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();

    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    this.dropdownPosition = {
      top: `${rect.bottom + window.scrollY}px`,
      left: `${rect.left + window.scrollX}px`,
      maxHeight: `${viewportHeight - (rect.bottom + window.scrollY)}px`, // space below the element
      maxWidth: `${viewportWidth - (rect.left + window.scrollY + 10)}px`,
      // overflowY: viewportWidth - rect.left <= 1024 ? 'auto' : 'none',
      overflowY: 'auto',
    };
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  onSelectionChange(value: any): void {
    this.selectedValue = value;
    const formattedStart = moment(value?.['start']).format('DD-MM-YYYY');
    this.departureTypeInput = formattedStart;
    this.firstFormGroup.get('departureDate')?.setValue(formattedStart);
    const tripDurationControl = this.firstFormGroup.get('tripDuration');

    if (tripDurationControl) {
      if (!tripDurationControl.value || tripDurationControl.value === 0) {
        this.currentTripDurationIndex = 0;
        tripDurationControl.setValue(this.tripDurationOptions[0]);
      }
    }
    this.isDropdownVisible = false;
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    if (!(event.target as HTMLElement).closest('.departure-date-picker')) {
      this.isDropdownVisible = false;
    }

    if (!(event.target as HTMLElement).closest('.travellers-input')) {
      this.isAdultsDropdownVisible = false;
    }
  }

  openAdultsDropdown(event: MouseEvent): void {
    const dialogRef = this.dialog.open(CoTravellerComponent, {
      height: 'auto',
      width: '500px',
      hasBackdrop: true,
      backdropClass: 'custom-backdrop',
      panelClass: 'lead-form-panel',
      disableClose: true,
      data: this.travellerModalState || { data: 'Default State' },
    });

    // Perform an action after the modal is closed
    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined) {
        return;
      }
      this.travellerModalState = result;
      this.rooms = result?.travellers;
      this.calculateTotalCoTraveller(result?.travellers);
      this.updateCoTravellerPlaceholder();
    });
  }

  calculateTotalCoTraveller(
    data: Array<{
      roomNumber: number;
      adults: number;
      child: number;
      infant: number;
    }>
  ) {
    this.totalRooms = data?.length;
    this.totalAdults = data?.reduce((sum, item) => sum + item.adults, 0);
    this.totalChildren = data?.reduce((sum, item) => sum + item.child, 0);
    this.totalInfants = data?.reduce((sum, item) => sum + item.infant, 0);

    this.firstFormGroup.patchValue({
      adults: this.totalAdults,
      child: this.totalChildren,
      infant: this.totalInfants,
    });
  }

  onDestinationSearch(term: any): void {
    this.destinationSearch$.next(term); // Push the search term into the subject
  }

  toggleWhatsAppSelection() {
    const existingValue = this.firstFormGroup.get('sendUpdatesViaWhatsApp')
      ?.value
      ? true
      : false;

    this.firstFormGroup.patchValue({
      sendUpdatesViaWhatsApp: !existingValue,
    });
  }

  getDateFromWeekString(weekString: string): string {
    // Split the input to extract month, year, and week details.
    const [monthYear, week] = weekString.split(' - ');
    const [month, year] = monthYear.split(' ');

    // Map of months to their corresponding numbers.
    const monthMap: { [key: string]: string } = {
      January: '01',
      February: '02',
      March: '03',
      April: '04',
      May: '05',
      June: '06',
      July: '07',
      August: '08',
      September: '09',
      October: '10',
      November: '11',
      December: '12',
    };

    // Get the month number from the month name.
    const monthNumber = monthMap[month];

    // Determine the date based on the week.
    let day: string;
    switch (week) {
      case '1st Week':
        day = '01'; // First day of the 1st week (1-7)
        break;
      case '2nd Week':
        day = '08'; // First day of the 2nd week (8-14)
        break;
      case '3rd Week':
        day = '15'; // First day of the 3rd week (15-21)
        break;
      case '4th Week':
        day = '22'; // First day of the 4th week (22-28)
        break;
      default:
        throw new Error('Invalid week specified');
    }

    // Return the formatted date.
    return `${month} ${year} - ${week}`;
  }

  ngOnDestroy(): void {
    this.travellerModalState = null;
  }
}
